import { useCallback } from 'react';
import { MapPinIcon, BoltIcon, CalendarIcon } from '@heroicons/react/24/outline';
import { formatDate } from '../util/data-factory';
import { logShowDetailsClickEvent } from '../util/events';
import { useRouter } from './../util/router';
import { useAuth } from './../util/auth';
import ShowImagePlaceholder from './ShowImagePlaceholder';

const SecondaryShowTile = ({ show, today }) => {
  const auth = useAuth();
  const router = useRouter();

  const handleShowClick = useCallback(
    showId => {
      router.push(`/show/${showId}`);

      void logShowDetailsClickEvent(auth.user?.id ?? null, String(showId), 'similar/nearby').catch(
        err => console.error('Event tracking failed:', err)
      );
    },
    [auth.user?.id]
  );

  return (
    <div className="p-2 bg-gray-100 overflow-auto text-black">
      <div
        className="relative md:max-h-[390px] mb-1 md:mb-5 overflow-hidden content-end cursor-pointer"
        onClick={() => handleShowClick(show.show_id)}
      >
        {show?.image_urls?.[0] ? (
          <>
            {show.recommended && (
              <div className="absolute top-2 left-2 py-0 pr-1 bg-off-white flex items-center gap-1 z-10">
                <BoltIcon className="w-5" />
                <small>Trending</small>
              </div>
            )}
            <img className="min-w-full m-auto" src={show.image_urls[0]} alt="" />
          </>
        ) : (
          <ShowImagePlaceholder />
        )}
      </div>

      <h1
        className="text-lg font-medium cursor-pointer"
        onClick={() => handleShowClick(show.show_id)}
      >
        {show?.display_title}
      </h1>

      <div className="flex flex-1 flex-wrap my-1 text-xs text-black/60 items-center">
        <div className="flex mr-4 mb-2 items-center">
          <MapPinIcon className="w-5" /> {show.venues.venue_name}
        </div>
        <div className="flex mr-4 mb-2 items-center">
          <CalendarIcon className="w-5 mr-1" /> {formatDate(show.start_date)} -{' '}
          {formatDate(show.end_date)}
        </div>
      </div>
    </div>
  );
};

export default SecondaryShowTile;
